<template>
  <div
    class="benefits"
    :class="{ dark: isDark }"
  >
    <ControlSlider
      :variant="isDark ? 'dark' : 'light'"
      hide-navigation-desktop
    >
      <template #slides>
        <div
          v-for="(item, index) in benefits"
          :key="index"
          class="benefits-item"
        >
          <NuxtImg
            :src="item.icon"
            :alt="item.title"
          />
          <h2>{{ item.title }}</h2>
          <p>{{ item.description }}</p>
        </div>
      </template>
    </ControlSlider>
  </div>
</template>

<script>
import ControlSlider from '~/components/Common/ControlSlider/ControlSlider.vue';

export default {
  components: { ControlSlider },
  props: {
    isDark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      benefits: [
        {
          title: 'Get seen by the right people',
          description:
            "Thousands of companies use Proxify to headhunt top engineers. You focus on the work, we make sure you're seen.",
          icon: '/images/roles/hero/grow_your_career.svg',
        },
        {
          title: "Where you live shouldn't limit your future",
          description:
            'Access career-growing opportunities from wherever you call home. Your location is never a barrier.',
          icon: '/images/roles/hero/remote_only.svg',
        },
        {
          title: 'Long-term focus',
          description:
            'No hotfixes or quick gigs, join teams for the long haul. Many of our developers stay with clients for years.',
          icon: '/images/roles/hero/get_paid.svg',
        },
        {
          title: 'We handle everything',
          description:
            'We take care of contracts, compliance, and payments so you can focus on what matters.',
          icon: '/images/roles/hero/talent_support.svg',
        },
      ],
    };
  },
};
</script>

<style lang="scss" src="./BenefitsSection.scss" scoped />
